import React from "react";
import { useTheme, useMediaQuery } from "@mui/material";

export default () => (Component) =>
    function (props) {
        const theme = useTheme();
        const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
        return <Component fullScreen={fullScreen} {...props} />;
    };
